(function () {
    'use strict';

    function adminEntityConfigurationsController(adminEntityConfigurationsData) {
        var vm = this;

        vm.adminEntityConfigurations = adminEntityConfigurationsData;
    }

    adminEntityConfigurationsController.$inject = ['adminEntityConfigurationsData'];

    angular.module('ecap.siteConfiguration').controller('adminEntityConfigurationsController', adminEntityConfigurationsController);
})();
